<template>
  <v-card>
    <v-row dense>
      <v-col>
        <v-card-title>
          Payout History
        </v-card-title>
        <v-card-subtitle v-if="billing.loginUrl">
          <v-btn text color="info" class="px-1" :href="billing.loginUrl">
            Stripe Dashboard
            <v-icon class="ml-2" small>
              open_in_new
            </v-icon>
          </v-btn>
        </v-card-subtitle>
      </v-col>
      <v-spacer class="limited-spacer"></v-spacer>
      <v-col cols="auto" class="my-auto success--text font-weight-bold text-h6">
        {{ totalCommissionEarned | currency }}
      </v-col>
      <v-col class="my-auto pr-4" cols="auto">
        <timeframe-select
          v-model="filter"
          v-on:change="refreshData"
        ></timeframe-select>
      </v-col>
    </v-row>
    <v-card-text class="pb-0">
      <loading-spinner v-if="loading"> </loading-spinner>
      <template v-else>
        <trend-chart
          :loading="loading"
          :height="250"
          :trend-data="trendData"
          y-axes-fluid
        ></trend-chart>
      </template>
    </v-card-text>
    <v-card-text>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="items"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100]
        }"
      >
        <template v-slot:item.date="{ item }">
          {{ item.date | longDate }}
        </template>
        <template v-slot:item.totalRevenue="{ item }">
          {{ item.totalRevenue | currency }}
        </template>
        <template v-slot:item.commissionPercent="{ item }">
          {{ item.commissionPercent | no_decimal }}%
        </template>
        <template v-slot:item.commissionEarned="{ item }">
          {{ item.commissionEarned | currency }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import TrendChart from "@/components/reporting/TrendChart";
import TimeframeSelect from "@/components/reporting/TimeframeSelect";
import { mapGetters } from "vuex";
export default {
  name: "PartnerBillingHistory",
  components: { TrendChart, TimeframeSelect },
  data: () => ({
    loading: false,
    filter: null,
    headers: [
      { text: "Sent On", value: "date" },
      { text: "Total Revenue", value: "totalRevenue" },
      { text: "Commission %", value: "commissionPercent" },
      { text: "Commission Earned", value: "commissionEarned" }
    ]
  }),
  computed: {
    totalCommissionEarned() {
      return this._.sumBy(this.history, "commissionEarned");
    },
    trendData() {
      return this.history.map(x => ({
        date: x.date,
        value: x.commissionEarned
      }));
    },
    items() {
      return this.history;
    },
    ...mapGetters({
      history: "billing/partner_history",
      billing: "billing/partner_billing"
    })
  },
  created() {
    this.filter = { timeframeId: this.$enums.timeframes.LAST_90_DAYS };
    this.refreshData();
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.$store
        .dispatch("billing/getPartnerHistory", this.filter)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading partner billing history."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
